<div>
    <app-titulo [inputTitulo]="'CHAT'" [inputSubtitulo]="'Ponte en contacto con nosotors'"></app-titulo>
</div>

<div class="CExpandir">
    <iframe id="iframeTuf" class="CExpandir" src="https://ventas.tufesa.com.mx/Tufechat2/default.aspx" frameBorder="0"></iframe>
</div>